/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { TicketType } from '@touchplan/common';
import { TicketTypeUpdateStatus } from 'src/app/app-data/models/ticket-type/TicketTypeExtensions';
import { TicketFormControls } from './ticket-form-controls.enum';

export const ticketFormTypeConfig = {
	[TicketType.Task]: [
		TicketFormControls.activityName,
		TicketFormControls.externalScheduleId,
		TicketFormControls.wbsCode,
		TicketFormControls.livePlanGranularity,
		TicketFormControls.liveCrewSize,
		TicketFormControls.liveDurationDays,
		TicketFormControls.liveFinish,
		TicketFormControls.liveRole,
		TicketFormControls.liveStart,
		TicketFormControls.liveWorkingDays,
		TicketFormControls.liveWorkSchedule,
		TicketFormControls.location,
		TicketFormControls.customFields,
		TicketFormControls.liveStartTime,
		TicketFormControls.liveFinishTime,
		TicketFormControls.liveDurationHours,
	],
	[TicketType.Milestone]: [
		TicketFormControls.activityName,
		TicketFormControls.milestoneType,
		TicketFormControls.externalScheduleId,
		TicketFormControls.wbsCode,
		TicketFormControls.liveFinish,
		TicketFormControls.liveFinishTime,
		TicketFormControls.liveRole,
		TicketFormControls.location,
		TicketFormControls.customFields,
	],
	[TicketType.Constraint]: [
		TicketFormControls.activityName,
		TicketFormControls.externalScheduleId,
		TicketFormControls.wbsCode,
		// At one point, only one of these two will be in formGroup.
		// If you assign ticket to somebody - it shows assignedProjectMember
		// If that person accepted the assignation - it shoes responsibleProjectMember
		// See TicketFormManager.updateAssignedAndResponsibleProjectMember
		TicketFormControls.assignedProjectMember,
		TicketFormControls.responsibleProjectMember,

		TicketFormControls.dateRequested,
		TicketFormControls.liveFinish,
		TicketFormControls.liveFinishTime,
		TicketFormControls.location,
		TicketFormControls.priority,
		TicketFormControls.requestedByProjectMember,
		TicketFormControls.customFields,
	],
	[TicketTypeUpdateStatus.TaskUpdateStatusDialogForMobile]: [
		TicketFormControls.liveCrewSize,
		TicketFormControls.liveDurationDays,
		TicketFormControls.liveStart,
		TicketFormControls.liveFinish,
		TicketFormControls.liveWorkingDays,
		TicketFormControls.varianceReason,
		TicketFormControls.varianceComment,
	],
	[TicketTypeUpdateStatus.TaskUpdateStatusDialogForDesktop]: [
		TicketFormControls.liveCrewSize,
		TicketFormControls.liveDurationDays,
		TicketFormControls.liveStart,
		TicketFormControls.liveFinish,
		TicketFormControls.liveWorkingDays,
	],
	[TicketTypeUpdateStatus.MilestoneUpdateStatusDialogForMobile]: [
		TicketFormControls.liveFinish,
		TicketFormControls.varianceReason,
		TicketFormControls.varianceComment,
	],
	[TicketTypeUpdateStatus.MilestoneUpdateStatusDialogForDesktop]: [TicketFormControls.liveFinish],
	[TicketTypeUpdateStatus.ConstraintUpdateStatusDialog]: [TicketFormControls.liveFinish],
	[TicketTypeUpdateStatus.MasterScheduleTask]: [
		TicketFormControls.activityName,
		TicketFormControls.externalScheduleId,
		// TicketFormControls.liveCrewSize,
		TicketFormControls.liveDurationDays,
		TicketFormControls.liveFinish,
		// TicketFormControls.liveRole,
		TicketFormControls.liveStart,
		TicketFormControls.liveWorkingDays,
		TicketFormControls.location,
		TicketFormControls.masterScheduleLink,
		TicketFormControls.customFields,
	],
} as const;
